import styled from "styled-components";

export const StyledWalletsWrapper = styled.div`
  .tab-body {
    @media screen and (max-width: 992px) {
      padding: 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
  }

  .content-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;
    
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }
`;

export const StyledWalletListWrapper = styled.div`
  .wallet-table {
    @media screen and (max-width: 992px) {
      min-width: 100%;
      overflow-x: inherit;
      &__head {
        display: none;
      }

      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 50%);
        border: 1px solid ${({theme}) => theme.surface.border};

        & > div {
          padding-top: 20px;

          &:before {
            display: block;
          }
        }
      }
    }

    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
    }
  }
`;

export const StyledWalletDetailsWrapper = styled.div`
  .tab-body {
    @media screen and (max-width: 992px) {
      padding: 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }

    .content-head {
      padding: 20px 0;
      display: grid;
      align-items: center;
      grid-template-columns: max-content 175px;
      grid-gap: 20px;

      @media screen and (max-width: 768px) {
        grid-template-columns: 100%;
      }
    }
  }

  .wallet-details-head {
    margin-bottom: 20px;
  }

  .wallet-info {
    display: grid;
    grid-template-columns: minmax(min-content, max-content) 1fr;
    grid-gap: 50px;

    @media screen and (max-width: 992px) {
      grid-template-columns: 100%;
      grid-gap: 30px;
    }

    &__content {
      display: flex;
      flex-wrap: wrap;
      column-gap: 30px;
      row-gap: 16px;
    }

    &__row {
      display: grid;
      grid-template-columns: 20px 1fr;
      grid-gap: 20px;
      align-items: center;

      span {
        color: ${({theme}) => theme.text.primary};
        font-size: 20px;
      }
    }
  }

  .currency {
    display: grid;
    grid-template-columns: 70px auto;
    grid-gap: 20px;
    align-items: center;

    &__name {
      color: ${({theme}) => theme.text.primary};
      font-size: 18px;
      font-weight: 600;
      display: flex;
      flex-wrap: wrap;
      gap: 5px;

      span {
        opacity: 0.25;
      }
    }

    &__image {
      width: 70px;
      height: 70px;
      color: ${({theme}) => theme.text.inverse};
      font-size: 32px;
      font-weight: 600;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${({theme}) => theme.brand.secondary};
      border-radius: 50%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }

  .transactions-table_scroll {
    @media screen and (max-width: 992px) {
      overflow: inherit;
    }
  }

  .transactions-table {
    &__head, &__row {
      grid-template-columns: repeat(2, minmax(210px, .85fr)) repeat(9, minmax(150px, 1fr)) repeat(2, minmax(150px, 1fr)) minmax(210px, .85fr) 220px;
    }

    .note {
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head {
        display: none;
      }

      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid ${({theme}) => theme.surface.border};

        & > div {
          padding-top: 20px;

          &:before {
            display: block;
          }
        }
      }

      &__note {
        max-width: 100%;
        white-space: inherit;
        overflow: inherit;
        grid-column-start: 1;
        grid-column-end: 3;
      }

      .icon-light-info {
        display: none;
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }

      &__note {
        grid-column-end: 1;
      }
    }
  }
`;

export const StyledReservedBalanceHistoryWrapper = styled.div`
  .reserved-balance-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 1fr;
    grid-gap: 25px;

    &__left {
      display: grid;
      align-items: center;
      grid-template-columns: max-content 175px;
      grid-template-rows: 1fr;
      grid-gap: 20px;
      
      @media screen and (max-width: 576px) {
        grid-template-columns: 175px max-content;
      }
    }

    @media screen and (max-width: 992px) {
      grid-template-columns: repeat(2, max-content);
      grid-gap: 20px;
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }

    &__create-invoice {
      display: inline-grid;
      align-items: center;
      grid-template-rows: 45px;
      justify-content: end;

      button {
        height: 100%;
      }
      
      @media screen and (max-width: 992px) {
        justify-content: start;
      }
    }
  }

  .reserved-balance-amount {
    padding: 0 20px;
    color: ${({theme}) => theme.text.primary};
    font-size: 18px;
    font-weight: 600;
  }
`;